import React from "react";
import BlockyLightText from "components/custom-texts/blocky-light-text.tsx";

const OrSeparator = () => {
  return (
    <div className="d-flex align-items-center my-3">
      <div className="flex-grow-1" style={{ height: '1px', backgroundColor: "white" }}></div>
      <div className="px-3">
        <BlockyLightText style={{ color: "white" }}>OR</BlockyLightText>
      </div>
      <div className="flex-grow-1" style={{ height: '1px', backgroundColor: "white" }}></div>
    </div>
  );
};

export default OrSeparator;